const lockDateFormat = new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
});

/** "21 Oct 2026, 14:05" (the boards' date format for lock facts and the locked-pages table); the raw value when it is not a date. */
export function formatLockDate(value: string | null | undefined): string {
    if (!value) return "";
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : lockDateFormat.format(date);
}
